var map = {
	"./dashboard/bg": 1393,
	"./dashboard/bg.jpg": 1393,
	"./fav": 1394,
	"./fav.png": 1394,
	"./login/login_bg": 1395,
	"./login/login_bg.jpg": 1395,
	"./other-images/bg-profile": 1396,
	"./other-images/bg-profile.png": 1396,
	"./other-images/boxbg": 1397,
	"./other-images/boxbg.jpg": 1397,
	"./other-images/calender-bg": 1398,
	"./other-images/calender-bg.png": 1398,
	"./other-images/coming-soon-bg": 1399,
	"./other-images/coming-soon-bg.jpg": 1399,
	"./other-images/maintenance-bg": 1400,
	"./other-images/maintenance-bg.jpg": 1400,
	"./other-images/mobile-clock-wallpaper": 1401,
	"./other-images/mobile-clock-wallpaper.jpg": 1401,
	"./other-images/sad": 233,
	"./other-images/sad.png": 233,
	"./social-app/social-image": 1402,
	"./social-app/social-image.png": 1402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1417;